import { create } from "zustand"
import { mergeCore, partializeCore } from "@stores/core"
import { persist } from "zustand/middleware"

type AppState = {
  primaryColor: string | null
  actions: {
    setPrimaryColor: (color: string | null) => void
  }
}

const initState: Omit<AppState, "actions"> = {
  primaryColor: null,
}

export const useAppStore = create(
  persist<AppState, [], [], Omit<AppState, "actions">>(
    (set, get) => ({
      ...initState,
      actions: {
        setPrimaryColor: (primaryColor) => {
          set({ primaryColor })
        },
      },
    }),
    {
      name: "employee-store",
      partialize: (state) => partializeCore(state, ["actions"]),
      merge: mergeCore,
    }
  )
)
